























import { Component, Vue } from 'vue-property-decorator'
import { getEquipmentInfoRequest } from '@/api/enerySupervision'

@Component
export default class Login extends Vue {
  private data: any = [];
  private columns: any = [
    {
      title: '主要耗能设备名称',
      dataIndex: 'name',
      key: 'name',
      scopedSlots: { customRender: 'name' },
      width: 300,
      children: [
        {
          title: '设备类型',
          dataIndex: 'deviceType',
          width: 100,
          align: 'center'
        },
        {
          title: '序号',
          dataIndex: 'seqNum',
          width: 100,
          align: 'center'
        },
        {
          title: '设备名称',
          dataIndex: 'deviceName',
          width: 100,
          align: 'center'
        },
      ],
    },
    {
      title: '设备概况',
      dataIndex: 'age',
      key: 'gaikuo',
      width: 300,
      children: [
        {
          title: '型号及数量',
          dataIndex: 'modelNum',
          width: 100,
          align: 'center'
        },
        {
          title: '功率/容量',
          dataIndex: 'powerCapacity',
          width: 100,
          align: 'center'
        },
        {
          title: '主要技术参数',
          dataIndex: 'mainParam',
          width: 100,
          align: 'center'
        },
      ],
    },
    {
      title: '设备运行状况',
      dataIndex: 'address',
      key: 'address 1',
      ellipsis: true,
      children: [
        {
          title: '负载率(%)',
          dataIndex: 'loadRate',
          width: 100,
          align: 'center'
        },
        {
          title: '运行时间(h)',
          dataIndex: 'runTime',
          width: 100,
          align: 'center'
        },
        {
          title: '设备大修',
          dataIndex: 'deviceOverhaul',
          width: 100,
          align: 'center'
        },
        {
          title: '故障',
          dataIndex: 'fault',
          width: 100,
          align: 'center'
        },
      ],
    },
    {
      title: '淘汰更新情况',
      dataIndex: 'address',
      key: 'address 2',
      ellipsis: true,
      children: [
        {
          title: '是否属于淘汰设备',
          dataIndex: 'disuseFlag',
          width: 100,
          align: 'center'
        },
        {
          title: '计划更新时间',
          dataIndex: 'scheduleUpdateTime',
          width: 100,
          align: 'center'
        },
      ],
    },
    {
      title: '检测情况',
      dataIndex: 'address',
      key: 'address 3',
      ellipsis: true,
      children: [
        {
          title: '项目',
          dataIndex: 'project',
          width: 100,
          align: 'center'
        },
        {
          title: '指标',
          dataIndex: 'norm',
          width: 100,
          align: 'center'
        },
      ],
    },
    {
      title: '备注',
      dataIndex: 'remark',
      ellipsis: true,
      align: 'center'
    }
  ];

  async getEquipmentInfo(params: any) {
    const { status, data } = await getEquipmentInfoRequest({ id: params })
    if (status == 0 && data) {
      this.data = data
    }
  }

  created() {
    if (this.$route.query.code) {
      this.getEquipmentInfo(this.$route.query.code)
    }
  }
}
